import { chartActions } from '../../services';

export const chartReducer = ( state = {}, action ) => {
  switch ( action.type ) {
    case chartActions.LOAD:
      return Object.assign( {}, state, { [action.chartName]: action.data } );
    default:
      return state;
  }
};